/**
 * Backward-compatible re-export for shared rendering helpers.
 *
 * New Galaxy code should import from `src/shared/rendering.ts` so shared utilities
 * are not owned by the legacy `components/` namespace. This file remains as a
 * compatibility facade for app bootstrap/auth/tests and older imports.
 */

export * from '../shared/rendering.js'
